var _defs, _defs2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkrainian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x35_0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 255.999,
    id: "SVGID_1_",
    r: 219
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UKRAINE_2_",
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 446.346,
    id: "SVGID_3_",
    width: 766.991,
    x: -129.202,
    y: 32.348
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_3_"
  })), /*#__PURE__*/React.createElement("rect", {
    height: 446.346,
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#4D72C0"
    },
    width: 766.991,
    x: -129.202,
    y: 32.348
  }), /*#__PURE__*/React.createElement("rect", {
    height: 223.16,
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#F2DD30"
    },
    width: 766.991,
    x: -129.202,
    y: 255.535
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkrainian);
export default __webpack_public_path__ + "static/media/ukrainian.13e18ad83cecbf50ebeab7d48e7d9c6a.svg";
export { ForwardRef as ReactComponent };